import React from "react";
import { AssistantChatContainer } from "./AssistantChatContainer";
import { PublicWorkspaceDTO } from "shared/services";
import Icon from "@mdi/react";
import { mdiRobotHappy } from "@mdi/js";
import styles from "../styles.module.scss";

interface AssistantPageProps {
	workspace: PublicWorkspaceDTO | null;
}

export const AssistantPage: React.FC<AssistantPageProps> = ({ workspace }) => {
	return (
		<div className={styles.chatPanel}>
			<header className={styles.chatHeader}>
				<div className={styles.chatHeaderInfo}>
					<div className={styles.chatHeaderAvatar}>
						<Icon
							path={mdiRobotHappy}
							size={0.9}
						/>
					</div>
					<div>
						<h2 className={styles.chatHeaderName}>Meu assistente</h2>
					</div>
				</div>
			</header>
			<div className={styles.chatArea}>
				<AssistantChatContainer
					embedded
					workspaceId={workspace ? String(workspace.id) : null}
				/>
			</div>
		</div>
	);
};
